import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { distinctUntilChanged } from 'rxjs/operators';

@Injectable({
    providedIn: 'root',
})
export class LoadingService {
    private loading = new BehaviorSubject<{ message: string | null; value: boolean }>({ message: null, value: false });

    get loading$(): Observable<{ message: string | null; value: boolean }> {
        return this.loading.pipe(
            distinctUntilChanged(
                (x: { message: string | null; value: boolean }, y: { message: string | null; value: boolean }) =>
                    this.isDistinct(x, y)
            )
        );
    }

    set(value: { message: string | null; value: boolean }): void {
        this.loading.next(value);
    }

    isDistinct(x: { message: string | null; value: boolean }, y: { message: string | null; value: boolean }) {
        if (x == null && y != null) {
            return false;
        }
        if (y == null && x != null) {
            return false;
        }
        if (x == null && y == null) {
            return true;
        }
        return x.value === y.value && x.message === y.message;
    }
}
